// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-page-body{padding-top:20px;padding-right:16px;padding-bottom:24px;padding-left:16px;overflow:auto;flex-grow:1;display:flex;flex-direction:column;flex-wrap:nowrap;position:relative;scroll-behavior:smooth}.automation-theme .app-page-body{scroll-behavior:auto}", ""]);
// Exports
module.exports = exports;
